(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-wall"] && !Shopify.designMode) return;
  try {
    
  class WyrdoCardWall extends HTMLElement {
    connectedCallback() {
      this.focusLayer = this.querySelector('[data-wall-focus]');
      this.track = this.querySelector('[data-wall-track]');
      this._openCell = null;
      this._prevFocus = null;
      this._onKey = this._onKey.bind(this);
      this._onDocClick = this._onDocClick.bind(this);

      // open on ANY card click (delegate). Dupes are decorative (aria-hidden, not tabbable)
      // but still openable by mouse — on desktop most visible cards ARE dupes, so bailing on
      // aria-hidden was why click-to-focus appeared dead on desktop.
      this.addEventListener('click', (e) => {
        const cell = e.target.closest('.wyrdo-cardwall__cell');
        if (!cell) return;
        if (this.classList.contains('is-focusing')) return; // a card is already open
        e.stopPropagation();
        this.open(cell);
      });
    }

    open(cell) {
      const card = cell.querySelector('.wyrdo-qcard');
      if (!card) return;
      this._openCell = cell;
      this._prevFocus = document.activeElement;

      // clone the actual card node (accent SVG + logo come along for free)
      const clone = card.cloneNode(true);
      clone.classList.add('wyrdo-cardwall__focus-card');
      clone.setAttribute('tabindex', '-1');
      clone.setAttribute('role', 'button');
      clone.setAttribute('aria-label', 'Close card');
      this.focusLayer.replaceChildren(clone);
      this.focusLayer.hidden = false;
      this.classList.add('is-focusing');

      // close on: clicking the focused card, clicking anywhere else, Esc
      clone.addEventListener('click', (ev) => { ev.stopPropagation(); this.close(); });
      // defer the doc listener so the opening click doesn't immediately close it
      requestAnimationFrame(() => {
        document.addEventListener('click', this._onDocClick, true);
      });
      document.addEventListener('keydown', this._onKey);

      // move focus to the opened card (a11y)
      clone.focus({ preventScroll: true });
    }

    close() {
      if (!this.classList.contains('is-focusing')) return;
      this.classList.remove('is-focusing');
      this.focusLayer.replaceChildren();
      this.focusLayer.hidden = true;
      document.removeEventListener('click', this._onDocClick, true);
      document.removeEventListener('keydown', this._onKey);
      // restore focus to the wall card that was opened
      const restore = this._prevFocus || this._openCell;
      if (restore && typeof restore.focus === 'function') restore.focus({ preventScroll: true });
      this._openCell = null;
      this._prevFocus = null;
    }

    _onDocClick() {
      // any click outside the focused card closes it (the clone stops propagation)
      this.close();
    }

    _onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick, true);
      document.removeEventListener('keydown', this._onKey);
    }
  }
  if (!customElements.get('wyrdo-card-wall')) {
    customElements.define('wyrdo-card-wall', WyrdoCardWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorway-carousel"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-carousel> — progressive enhancement for a horizontal scroll-snap row.
     - prev/next arrows page by one card (scroll-snap lands it in view);
     - arrows disable at the ends and the whole nav hides when there's no overflow;
     - mouse pointer-drag scrolls the row (touch/pen keep native scrolling);
     - a drag past threshold swallows the trailing click so a card link / Add-to-cart
       isn't fired at the end of a drag. */
  if (!customElements.get('wyrdo-carousel')) {
    customElements.define('wyrdo-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.nav = this.querySelector('[data-carousel-nav]');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        this._update = this._update.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => { this._raf = null; this._update(); });
        }, { passive: true });
        window.addEventListener('resize', this._update);

        this._wireDrag();
        requestAnimationFrame(this._update);
      }

      disconnectedCallback() { window.removeEventListener('resize', this._update); }

      // one card = first cell's width + the flex gap
      step() {
        const cell = this.track.querySelector(':scope > *');
        if (!cell) return this.track.clientWidth * 0.8;
        const s = getComputedStyle(this.track);
        const gap = parseFloat(s.columnGap || s.gap || '0') || 0;
        return cell.getBoundingClientRect().width + gap;
      }

      page(dir) {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: dir * this.step(), behavior: behavior });
      }

      _update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const hasOverflow = max > 4;
        if (this.nav) this.nav.hidden = !hasOverflow;
        const x = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = x <= 2;
        if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
      }

      _wireDrag() {
        const track = this.track;
        let down = false, moved = false, startX = 0, startLeft = 0;
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;       // touch/pen use native scrolling
          down = true; moved = false;
          startX = e.clientX; startLeft = track.scrollLeft;
        });
        track.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
        });
        const end = () => {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');       // restores scroll-snap → snaps to a card
        };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        // a real drag ends in a click; swallow it so a card link / Add-to-cart doesn't fire
        track.addEventListener('click', (e) => {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wyrdo-faq')) {
    customElements.define('wyrdo-faq', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-single')) return;
        this.addEventListener('toggle', (e) => {
          if (!e.target.open) return;
          this.querySelectorAll('details[open]').forEach((d) => { if (d !== e.target) d.open = false; });
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* I.18: a pick submits the country form by itself. Arrow keys on a closed select also fire `change` (Windows), so a
     keyboard change waits for Enter or the Switch button instead of reloading the page on every step. */
  (() => {
    let keyed = false;
    const pick = (e) => e.target instanceof HTMLSelectElement && e.target.matches('[data-country-select]');
    document.addEventListener('pointerdown', (e) => { if (pick(e)) keyed = false; });
    document.addEventListener('keydown', (e) => {
      if (!pick(e)) return;
      keyed = e.key !== 'Enter' && e.key !== 'Tab';
      if (e.key === 'Enter') { e.preventDefault(); e.target.form.submit(); }
    });
    document.addEventListener('change', (e) => { if (pick(e) && !keyed) e.target.form.submit(); keyed = false; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* <wyrdo-header> — menu overlay enhancement: Escape closes, focus stays inside, the page
     doesn't scroll behind it, and any in-page link closes it. The <details> works without this. */
  if (!customElements.get('wyrdo-header')) {
    /* the free-pack announcement (data-kl-form) opens Klaviyo's claim pop-up. _klOnsite is Klaviyo's
       onsite queue — the app embed defines it synchronously, before klaviyo.js loads — and
       push(['openForm', id]) opens the form whether or not the script has finished loading (Klaviyo's
       documented load-order-safe trigger). If the embed is blocked/absent it stays a plain link. */
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-kl-form]');
      if (!a || !window._klOnsite) return;
      e.preventDefault();
      a.closest('details[open]')?.removeAttribute('open');   // the menu's copy: close the menu first
      window._klOnsite.push(['openForm', a.dataset.klForm]);
    });
    customElements.define('wyrdo-header', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('[data-menu]');
        this.panel = this.querySelector('[data-menu-panel]');
        if (!this.details || !this.panel) return;
        this.details.addEventListener('toggle', () => this._sync());
        this._onKey = (e) => {
          if (!this.details.open) return;
          if (e.key === 'Escape') { this.details.open = false; this.details.querySelector('summary').focus(); return; }
          if (e.key !== 'Tab') return;
          const f = this._focusables();
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        };
        document.addEventListener('keydown', this._onKey);
        this.panel.addEventListener('click', (e) => {
          const a = e.target.closest('a[href]');
          // an in-page link closes the menu: "#x", or this page's own URL + #x (outside Australia the announcement goes to the base game's #waitlist)
          if (a && a.hash && a.pathname === location.pathname) this.details.open = false;
        });
        this._wireScroll();
      }
      /* hide on scroll-down, return on scroll-up (classes on <html>; the CSS above does the rest) */
      _wireScroll() {
        const root = document.documentElement, group = this.closest('.shopify-section-group-header-group');
        const strips = group ? Array.from(group.querySelectorAll('[data-strip]')) : [];
        const measure = () => root.style.setProperty('--announce-h', strips.reduce((h, s) => h + s.offsetHeight, 0) + 'px');
        measure(); window.addEventListener('resize', measure, { passive: true });
        let last = window.scrollY, ticking = false;
        const update = () => {
          ticking = false;
          const y = window.scrollY, dy = y - last; last = y;
          if (y < 8) { root.classList.remove('wyrdo-hdr-pinned', 'wyrdo-hdr-hidden'); return; }
          if (this.details.open) return;
          if (dy > 2 && y > 120) { root.classList.add('wyrdo-hdr-hidden'); root.classList.remove('wyrdo-hdr-pinned'); }
          else if (dy < -2) { root.classList.add('wyrdo-hdr-pinned'); root.classList.remove('wyrdo-hdr-hidden'); }
        };
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      }
      disconnectedCallback() { document.removeEventListener('keydown', this._onKey); this._lock(false); }
      _focusables() {
        const list = [this.details.querySelector('summary')].concat(
          Array.from(this.panel.querySelectorAll('a[href], button:not([disabled])'))
        );
        return list.filter((el) => el.offsetParent !== null || el.tagName === 'SUMMARY');
      }
      _lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
      _sync() {
        const open = this.details.open;
        this._lock(open);
        if (open) {
          const first = this.panel.querySelector('a[href]');
          if (first) first.focus({ preventScroll: true });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-stage"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-hero-stage> — pinned stage + sticker pinball + the deal. Self-contained (own rAF loop)
     so it never depends on script order. See the section comment for the design. */
  if (!customElements.get('wyrdo-hero-stage')) {
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    const smooth = (t) => { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
    const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
    const FINE = window.matchMedia('(pointer: fine)');

    customElements.define('wyrdo-hero-stage', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.pin = this.querySelector('[data-pin]');
        this.lockup = this.querySelector('[data-lockup]');
        this.deck = this.querySelector('[data-deck]');
        this.counter = this.querySelector('[data-counter]');
        this.hint = this.querySelector('[data-hint]');
        this.ctl = this.querySelector('[data-ctl]');
        this.skip = this.querySelector('[data-skip]');
        this.slots = this.deck ? Array.from(this.deck.children) : [];
        this.N = this.slots.length;
        this.unit = (parseFloat(this.dataset.unit) || 60) / 100;
        this.peek = (parseFloat(this.dataset.peek) || 50) / 100;
        this.physicsMode = this.dataset.physics || 'lively';
        this.k = 0; this.f = 0; this.h = 0; this.prog = 0;
        this.flyout = false; this.live = true; this.busy = false;
        this.stickers = [];
        if (!this.stage || !this.N) return;

        this.mode = (REDUCE.matches || window.innerHeight < 480) ? 'static' : 'pinned';
        this._setup();
        this._wireInput();

        this._onScroll = this._onScroll.bind(this);
        this._onResize = this._onResize.bind(this);
        this._tick = this._tick.bind(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        window.addEventListener('pageshow', this._onResize);
        REDUCE.addEventListener('change', this._onResize);

        // only work while the stage is around the viewport
        this.io = new IntersectionObserver((es) => {
          this.near = es[0].isIntersecting;
          if (this.near) this._start(); else this._stop();
        }, { rootMargin: '30% 0px 30% 0px' });
        this.io.observe(this);
        this.lastY = window.scrollY;
        this._layout();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('pageshow', this._onResize);
        REDUCE.removeEventListener('change', this._onResize);
        if (this.io) this.io.disconnect();
        this._stop();
      }

      /* ---------- setup / measure ---------- */
      _setup() {
        this.H = this.stage.offsetHeight || window.innerHeight;
        this.W = this.stage.offsetWidth || window.innerWidth;
        if (this.mode === 'pinned') {
          this.classList.add('is-enhanced');
          this.style.height = Math.round(this.H + this.N * this.unit * this.H) + 'px';
          if (this.skip) this.skip.hidden = false;
          if (this.hint) this.hint.hidden = false;
          if (this.counter) this.counter.hidden = false;
        } else {
          this.classList.add('is-enhanced', 'is-static');
          this.style.height = '';
          if (this.ctl) this.ctl.classList.remove('is-on');
          if (this.skip) this.skip.hidden = true;
          if (this.hint) this.hint.hidden = true;
          if (this.counter) this.counter.hidden = true;
        }
        this.stage.style.setProperty('--peek-vh', String(this.peek * 100));
        this.peekPx = this.peek * this.H;
        this.deckW = this.deck.offsetWidth || 260;
        this.stage.style.setProperty('--deck-h', (this.deck.offsetHeight || 380) + 'px');   // the controls + hint hang off the pile
        this.flyout = false;                 // re-homed; _layout() re-flies them if the deal is on
        this._homeStickers(true);
      }

      _homeStickers(reset) {
        const bodies = Array.from(this.pin.children);
        this.stickers = bodies.map((el, i) => {
          const s = el.offsetWidth || 70;
          const px = parseFloat(el.dataset.x), py = parseFloat(el.dataset.y);
          const st = (reset || !this.stickers[i]) ? { el, kick: i * 0.9, phase: i * 1.3 } : this.stickers[i];
          st.s = s;
          // the composition lives in a centred field (max 1400px) so ultra-wide screens keep the stickers
          // near the lockup instead of spraying them to the edges
          const fw = Math.min(this.W, 1400), fx = (this.W - fw) / 2;
          st.hx = clamp(fx + px / 100 * fw - s / 2, -s * 0.2, Math.max(0, this.W - s * 0.8));
          st.hy = clamp(py / 100 * this.H - s / 2, 0, Math.max(0, this.H - s));
          st.home = parseFloat(el.dataset.r) || 0;
          if (reset || st.x === undefined) { st.x = st.hx; st.y = st.hy; st.ang = st.home; st.vx = 0; st.vy = 0; st.va = 0; }
          return st;
        });
        this._drawStickers();
      }

      _onResize() {
        const wantStatic = REDUCE.matches || window.innerHeight < 480;
        const mode = wantStatic ? 'static' : 'pinned';
        // iOS Safari fires resize while its toolbar collapses; the stage is 100svh so its box
        // doesn't change — only re-measure (and re-home the stickers) when it actually did.
        if (mode === this.mode && this.stage.offsetWidth === this.W && this.stage.offsetHeight === this.H) return;
        if (mode !== this.mode) { this.mode = mode; this.classList.remove('is-static'); }
        this._setup();
        this.lastY = window.scrollY;
        this._layout();
      }

      /* ---------- the loop ---------- */
      _start() { if (!this.raf) { this.last = 0; this.raf = requestAnimationFrame(this._tick); } }
      _stop() { if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; } }
      _tick(now) {
        this.raf = 0;
        const dt = this.last ? clamp((now - this.last) / 1000, 0.001, 0.05) : 1 / 60;
        this.last = now;
        if (this.mode === 'pinned' && this.physicsMode !== 'off' && !REDUCE.matches) this._physics(now / 1000, dt);
        if (this.near) this.raf = requestAnimationFrame(this._tick);
      }

      _onScroll() {
        const y = window.scrollY, dy = y - this.lastY; this.lastY = y;
        this._kick(dy);
        if (!this.ticking) {
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this._layout(); });
        }
      }

      /* ---------- pinball ---------- */
      _kick(dy) {
        if (this.mode !== 'pinned' || !this.live || this.flyout || this.physicsMode === 'off' || REDUCE.matches) return;
        const strength = this.physicsMode === 'calm' ? 0.2 : 0.42;
        const k = clamp(dy, -70, 70) * strength;
        if (!k) return;
        for (const s of this.stickers) {
          const a = s.kick + (dy > 0 ? 0 : Math.PI);
          s.vx += Math.cos(a) * k * (0.7 + Math.random() * 0.8);
          s.vy += Math.sin(a) * k * (0.7 + Math.random() * 0.8);
          s.va += (Math.random() - 0.5) * k * 0.5;
          s.kick += 2.1;
        }
      }
      _physics(t, dt) {
        const W = this.W, H = this.H, f = dt * 60;            // frame-rate independent
        const drag = Math.pow(0.965, f), adrag = Math.pow(0.95, f);
        const P = this.pointer;
        for (const s of this.stickers) {
          if (s.gone) continue;                                // already off the stage (fly-out)
          s.vx *= drag; s.vy *= drag; s.va *= adrag;
          if (this.flyout) {                                   // keep pushing outward until it has left
            const dx = s.x + s.s / 2 - W / 2, dy = s.y + s.s / 2 - H / 2, d = Math.hypot(dx, dy) || 1;
            s.vx += dx / d * 0.9 * f; s.vy += dy / d * 0.9 * f;
            if (s.x < -s.s * 1.2 || s.x > W + s.s * 0.2 || s.y < -s.s * 1.2 || s.y > H + s.s * 0.2) { s.gone = true; }
          }
          if (P && FINE.matches && !this.flyout) {            // desktop: the pointer nudges stickers away
            const dx = s.x + s.s / 2 - P.x, dy = s.y + s.s / 2 - P.y, d = Math.hypot(dx, dy);
            const r = s.s * 0.9;
            if (d < r && d > 0.1) { const push = (1 - d / r) * 1.6 * f; s.vx += dx / d * push; s.vy += dy / d * push; s.va += (dx / d) * push * 0.4; }
          }
          s.x += s.vx * f; s.y += s.vy * f; s.ang += s.va * f;
          if (!this.flyout) {
            const ox = s.s * 0.2;                              // stickers may overhang the side edges a little, like the mock
            if (s.x < -ox) { s.x = -ox; s.vx = -s.vx * 0.82; s.va += s.vy * 0.3; }
            else if (s.x > W - s.s + ox) { s.x = W - s.s + ox; s.vx = -s.vx * 0.82; s.va -= s.vy * 0.3; }
            if (s.y < 0) { s.y = 0; s.vy = -s.vy * 0.82; s.va += s.vx * 0.3; }
            else if (s.y > H - s.s) { s.y = H - s.s; s.vy = -s.vy * 0.82; s.va -= s.vx * 0.3; }
            // idle: a gentle bob around the mock position + a soft spring home, so a nudge
            // (pointer, a bounce) always settles back into the composition
            s.x += Math.sin(t * 0.9 + s.phase) * 0.12 * f;
            s.y += Math.cos(t * 0.7 + s.phase) * 0.12 * f;
            s.vx += (s.hx - s.x) * 0.0025 * f; s.vy += (s.hy - s.y) * 0.0025 * f;
            s.va += (s.home - s.ang) * 0.004 * f;
          }
        }
        this._drawStickers();
      }
      _drawStickers() {
        for (const s of this.stickers) {
          s.el.style.transform = 'translate3d(' + s.x.toFixed(1) + 'px,' + s.y.toFixed(1) + 'px,0) rotate(' + s.ang.toFixed(1) + 'deg)';
        }
      }
      _flyOut() {
        this.flyout = true;
        const W = this.W, H = this.H;
        for (const s of this.stickers) {
          const dx = s.x + s.s / 2 - W / 2, dy = s.y + s.s / 2 - H / 2, d = Math.hypot(dx, dy) || 1;
          s.vx = dx / d * 22; s.vy = dy / d * 22 - 4; s.va += (Math.random() - 0.5) * 12; s.gone = false;
        }
      }
      _flyHome() {
        this.flyout = false;
        for (const s of this.stickers) { s.x = s.hx; s.y = s.hy; s.ang = s.home; s.vx = (Math.random() - 0.5) * 2; s.vy = (Math.random() - 0.5) * 2; s.va = 0; s.gone = false; }
      }

      /* ---------- the deal: a neat stack; the front card flies clean off the edge, alternating sides ---------- */
      _layoutStack(k, f) {
        const N = this.N, W = this.deckW, fly = this.W / 2 + W;      // past the viewport edge, whatever the width
        for (let i = 0; i < N; i++) {
          const s = ((i - k) % N + N) % N;
          const el = this.slots[i];
          let t = 'translate(0,0)', z = 100 - s;
          if (s === 0 && f > 0) {
            const dir = i % 2 === 0 ? -1 : 1, A = smooth(f);          // card 1 left, card 2 right, …
            t = 'translate(' + (dir * A * fly).toFixed(1) + 'px,' + (A * 48).toFixed(1) + 'px) rotate(' + (dir * A * 26).toFixed(2) + 'deg)';
          } else if (s === 1) {
            t = 'scale(' + (0.96 + 0.04 * smooth(f)).toFixed(3) + ')';   // the next card grows into place as the front leaves
          } else if (s > 1) {
            t = 'scale(0.96)';
          }
          el.style.transform = t;
          el.style.zIndex = z;
          el.setAttribute('aria-hidden', s === 0 && f > 0.5 ? 'true' : 'false');
        }
        this.deck.setAttribute('data-front', String(((k % N) + N) % N + 1));
      }

      _layout() {
        if (this.mode !== 'pinned') { this._layoutStack(this.k, this.f); return; }
        const rect = this.getBoundingClientRect();
        const total = this.offsetHeight - this.H;
        const prog = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
        const p = prog * this.N;
        const h = Math.min(1, p);
        const cp = Math.max(0, p - 1);
        let k = Math.min(this.N - 1, Math.floor(cp)), f = cp - k;
        if (k === this.N - 1) f = 0;
        this.prog = prog; this.h = h; this.k = k; this.f = f;

        const sh = smooth(h);
        // the lockup shrinks where it stands (no fade); the rising deck covers what is left
        this.lockup.style.transform = 'translate(-50%,-50%) scale(' + (1 - 0.72 * sh).toFixed(3) + ')';
        this.lockup.style.visibility = h >= 1 ? 'hidden' : '';
        this.deck.style.transform = 'translate(-50%,-50%) translateY(' + ((1 - sh) * this.peekPx).toFixed(1) + 'px)';
        this._layoutStack(k, f);

        if (this.counter) {
          const front = Math.min(this.N, k + 1);
          this.counter.textContent = front + ' / ' + this.N;
        }
        // the controls slide up under the pile once the first card has (nearly) flown, and go with the stage
        if (this.ctl) this.ctl.classList.toggle('is-on', cp >= 0.9 && prog < 0.98);
        this.live = h < 1.01;
        if (h > 0.32 && !this.flyout) this._flyOut();
        if (h < 0.28 && this.flyout) this._flyHome();
        this.setAttribute('data-phase', h < 1 ? 'lockup' : (prog >= 0.98 ? 'done' : 'deal'));
      }

      /* ---------- input: tap / swipe / keys ---------- */
      _wireInput() {
        const deck = this.deck;
        if (this.dataset.tap === undefined) return;
        let down = null;
        deck.addEventListener('pointerdown', (e) => { down = { x: e.clientX, y: e.clientY, t: e.timeStamp }; });
        deck.addEventListener('pointerup', (e) => {
          if (!down) return;
          const dx = e.clientX - down.x, dy = e.clientY - down.y; down = null;
          if (e.target.closest('.wyrdo-censor')) return;
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) this.advance(1);
          else if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.advance(dx < 0 ? 1 : -1);
        });
        deck.addEventListener('pointercancel', () => { down = null; });
        deck.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.advance(1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); this.advance(-1); }
        });
        if (this.skip) this.skip.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: window.scrollY + this.getBoundingClientRect().bottom - 8, behavior: REDUCE.matches ? 'auto' : 'smooth' });
        });
        this.stage.addEventListener('pointermove', (e) => { if (FINE.matches) { const r = this.stage.getBoundingClientRect(); this.pointer = { x: e.clientX - r.left, y: e.clientY - r.top }; } }, { passive: true });
        this.stage.addEventListener('pointerleave', () => { this.pointer = null; });
      }

      advance(dir) {
        if (this.mode === 'pinned') {
          const total = this.offsetHeight - this.H;
          const top = window.scrollY + this.getBoundingClientRect().top;
          const targetK = clamp((this.h < 1 ? 0 : this.k) + dir, 0, this.N - 1);
          const targetP = 1 + targetK;                       // progress units: 1 = lockup gone
          window.scrollTo({ top: top + (targetP / this.N) * total, behavior: REDUCE.matches ? 'auto' : 'smooth' });
          return;
        }
        if (this.busy) return;
        const from = this.k, to = ((from + dir) % this.N + this.N) % this.N;
        if (REDUCE.matches || dir < 0) { this.k = to; this._layoutStack(this.k, 0); return; }
        this.busy = true;
        const start = performance.now(), dur = 560;
        const step = (now) => {
          const f = clamp((now - start) / dur, 0, 1);
          this._layoutStack(from, f);
          if (f < 1) requestAnimationFrame(step); else { this.k = to; this._layoutStack(this.k, 0); this.busy = false; }
        };
        requestAnimationFrame(step);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quote"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-quote-carousel> — auto-advancing, drag/swipeable quote carousel.
     Single-clock design: the ACTIVE dot's CSS fill animation IS the timer — when it
     finishes (animationend) the carousel advances, so the bar and the advance can never
     drift apart. Pausing = freezing that animation (is-paused). Reduced-motion / no
     [data-autoplay] → no sweep + no auto-advance, but dots + drag still navigate. */
  if (!customElements.get('wyrdo-quote-carousel')) {
    customElements.define('wyrdo-quote-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-quote-track]');
        this.slides = Array.from(this.querySelectorAll('[data-quote-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-quote-dot]'));
        this.count = this.slides.length;
        if (!this.track || this.count <= 1) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && !this.reduce;
        this.index = 0;

        this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));

        // the active fill finishing is the advance trigger (autoplay only)
        this.addEventListener('animationend', (e) => {
          if (this.autoplay && e.animationName === 'wyrdo-quote-fill') {
            this.goTo((this.index + 1) % this.count);
          }
        });

        // keep the dots in sync after a drag/swipe (native scroll settle)
        this.track.addEventListener('scroll', () => {
          clearTimeout(this._st);
          this._st = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index && i >= 0 && i < this.count) this.setActive(i);
          }, 90);
        }, { passive: true });

        // pause the sweep while the reader is engaged
        this.addEventListener('pointerenter', () => this.pause());
        this.addEventListener('pointerleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        this._wireDrag();
        this.setActive(0);
      }

      goTo(i) {
        const slide = this.slides[i];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
        this.setActive(i);
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((d, j) => d.setAttribute('aria-selected', j === i ? 'true' : 'false'));
        if (!this.autoplay) return;
        // force-restart the active dot's fill sweep (so re-selecting the same index replays)
        const fill = this.dots[i] && this.dots[i].querySelector('.wyrdo-pquote__dotfill');
        if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      }

      pause() { this.classList.add('is-paused'); }
      resume() { this.classList.remove('is-paused'); }

      _wireDrag() {
        const track = this.track;
        let down = false, moved = false, startX = 0, startLeft = 0;
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;   // touch/pen swipe natively
          down = true; moved = false;
          startX = e.clientX; startLeft = track.scrollLeft;
          this.pause();
        });
        track.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
        });
        const end = () => {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');
          this.resume();
          if (moved) {                              // snap to the nearest quote after a mouse drag
            const i = Math.round(track.scrollLeft / track.clientWidth);
            this.goTo(Math.max(0, Math.min(this.count - 1, i)));
          }
        };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        track.addEventListener('click', (e) => {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  /* <wyrdo-reviews> — the compact PDP quote carousel (snippets/pdp-reviews.liquid). Native touch swipe +
     tap-dots; when [data-autoplay], the active dot's CSS fill IS the timer — its animationend advances the
     carousel, so the bar and the advance can't drift apart. Pausing = freezing that fill (is-paused). No JS
     = a swipeable row with static dots. ponytail: trimmed copy of <wyrdo-quote-carousel> (press-quote.liquid). */
  if (!customElements.get('wyrdo-reviews')) {
    customElements.define('wyrdo-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rev-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rev-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-rev-dot]'));
        this.count = this.slides.length;
        if (!this.track || this.count <= 1) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && !this.reduce;
        this.index = 0;
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));
        this.addEventListener('animationend', (e) => {
          if (this.autoplay && e.animationName === 'wyrdo-rev-fill') this.goTo((this.index + 1) % this.count);
        });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this._st);
          this._st = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index && i >= 0 && i < this.count) this.setActive(i);
          }, 90);
        }, { passive: true });
        this.addEventListener('pointerenter', () => this.pause());
        this.addEventListener('pointerleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());
        this.setActive(0);
      }
      goTo(i) {
        const s = this.slides[i];
        if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
        this.setActive(i);
      }
      setActive(i) {
        this.index = i;
        this.dots.forEach((d, j) => d.setAttribute('aria-selected', j === i ? 'true' : 'false'));
        if (!this.autoplay) return;
        const fill = this.dots[i] && this.dots[i].querySelector('.wyrdo-rev__dotfill');
        if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      }
      pause() { this.classList.add('is-paused'); }
      resume() { this.classList.remove('is-paused'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shot"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-product-shot> — the ping-in. Entry progress (section top crossing 80% of the viewport)
     drives a back-out overshoot from off-frame; exit progress (bottom crossing 45%) flies them out
     the same way. Both are scrubbed by scroll, so scrolling back reverses them exactly. */
  if (!customElements.get('wyrdo-product-shot')) {
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    const smooth = (t) => { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
    const outBack = (t) => { const c1 = 1.70158, c3 = c1 + 1; t = clamp(t, 0, 1); return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
    const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

    customElements.define('wyrdo-product-shot', class extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-frame]');
        this.box = this.querySelector('[data-box]');
        this.pings = Array.from(this.querySelectorAll('[data-ping]')).map((el) => {
          const x = parseFloat(el.dataset.x), y = parseFloat(el.dataset.y);
          // fly from the nearest off-frame direction, relative to the frame centre
          const dx = x - 50, dy = y - 50, d = Math.hypot(dx, dy) || 1;
          return { fly: el.querySelector('[data-fly]'), ix: dx / d * 120, iy: dy / d * 120, ir: dx > 0 ? 200 : -200, ox: dx / d * 110, oy: dy / d * 110 - 20, or: dx > 0 ? 150 : -150 };
        });
        if (!this.frame || !this.pings.length) return;
        this._layout = this._layout.bind(this);
        this._onScroll = () => { if (this.near && !this.tick) { this.tick = true; requestAnimationFrame(() => { this.tick = false; this._layout(); }); } };
        this.io = new IntersectionObserver((es) => { this.near = es[0].isIntersecting; if (this.near) this._layout(); }, { rootMargin: '60% 0px 60% 0px' });
        this.io.observe(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._layout, { passive: true });
        window.addEventListener('pageshow', this._layout);
        this.lastY = window.scrollY; this.tilt = 0;
        this._layout();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._layout);
        window.removeEventListener('pageshow', this._layout);
        if (this.io) this.io.disconnect();
      }
      _layout() {
        const vh = window.innerHeight, rc = this.frame.getBoundingClientRect();
        const pIn = clamp((vh - rc.top) / (vh * 0.8), 0, 1);
        const pOut = clamp((vh * 0.45 - rc.bottom) / (vh * 0.3), 0, 1);
        const reduce = REDUCE.matches;
        const eIn = reduce ? 1 : outBack(pIn), eOut = reduce ? 0 : smooth(pOut);
        for (const p of this.pings) {
          const x = p.ix * (1 - eIn) + p.ox * eOut, y = p.iy * (1 - eIn) + p.oy * eOut;
          const r = p.ir * (1 - eIn) + p.or * eOut, sc = 0.5 + 0.5 * Math.min(1, eIn);
          p.fly.style.transform = 'translate(' + x.toFixed(2) + 'vw,' + y.toFixed(2) + 'vh) rotate(calc(var(--pr, 0deg) + ' + r.toFixed(1) + 'deg)) scale(' + sc.toFixed(3) + ')';
          p.fly.style.opacity = String(1 - eOut);
        }
        if (this.hasAttribute('data-tilt') && this.box && !reduce) {
          const y = window.scrollY, dy = clamp(y - this.lastY, -40, 40); this.lastY = y;
          this.tilt = this.tilt * 0.85 + dy * 0.05;
          this.box.style.transform = 'rotate(' + this.tilt.toFixed(2) + 'deg)';
          if (Math.abs(this.tilt) > 0.05 && !this.settling) {
            this.settling = true;
            const settle = () => { this.tilt *= 0.85; this.box.style.transform = 'rotate(' + this.tilt.toFixed(2) + 'deg)'; if (Math.abs(this.tilt) > 0.05) requestAnimationFrame(settle); else { this.box.style.transform = ''; this.settling = false; } };
            requestAnimationFrame(settle);
          }
        }
        this.setAttribute('data-state', pOut > 0 ? 'out' : (pIn >= 1 ? 'in' : 'entering'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral-owner"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-ref-owner> — read ?code=, switch to the code state, wire share / copy link / copy code. */
  if (!customElements.get('wyrdo-ref-owner')) {
    customElements.define('wyrdo-ref-owner', class extends HTMLElement {
      connectedCallback() {
        let code = '';
        try { code = (new URLSearchParams(window.location.search).get('code') || '').trim(); } catch (e) {}
        if (!/^REF-\d{3,6}$/i.test(code)) return;   // no code or not ours: the no-code state stays
        code = code.toUpperCase();
        const link = this.dataset.link.replace('[code]', code);   // code is REF- + digits: URL-safe
        const text = (this.dataset.share || '').replace('[code]', code).replace('[link]', link);
        this.querySelectorAll('[data-ref-code]').forEach((el) => { el.textContent = code; });
        this.classList.add('is-code');

        const copy = async (value) => {
          try { await navigator.clipboard.writeText(value); return; } catch (e) {}
          const t = document.createElement('textarea');
          t.value = value; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          t.remove();
        };
        const flash = (btn, msg) => {
          const s = btn.querySelector('[data-ref-label]');
          if (!s.dataset.was) s.dataset.was = s.textContent;
          s.textContent = msg;
          clearTimeout(btn._refT);
          btn._refT = setTimeout(() => { s.textContent = s.dataset.was; }, 2000);
        };

        const chip = this.querySelector('[data-ref-copy]');
        chip.addEventListener('click', () => copy(code).then(() => flash(chip, this.dataset.copied)));
        const linkBtn = this.querySelector('[data-ref-link]');
        linkBtn.addEventListener('click', () => copy(link).then(() => flash(linkBtn, this.dataset.copied)));
        const share = this.querySelector('[data-ref-share]');
        share.addEventListener('click', async () => {
          if (navigator.share) {
            try { await navigator.share({ text }); return; }
            catch (e) { if (e && e.name === 'AbortError') return; }   // they closed the sheet: nothing to say
          }
          await copy(text);
          flash(share, this.dataset.shared);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-carousel"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-shop-carousel> — enhancement for a scroll-snap row: arrows page by a card, pointer-drag
     for mouse users (a drag swallows the trailing click so Add-to-cart never fires by accident),
     dots follow the snapped card. Touch keeps native scrolling. */
  if (!customElements.get('wyrdo-shop-carousel')) {
    customElements.define('wyrdo-shop-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.cells = Array.from(this.track.querySelectorAll('[data-carousel-cell]'));
        this.nav = this.querySelector('[data-carousel-nav]');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this._update = this._update.bind(this);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(parseInt(d.dataset.carouselDot, 10))));
        this.track.addEventListener('scroll', () => { if (!this._raf) this._raf = requestAnimationFrame(() => { this._raf = null; this._update(); }); }, { passive: true });
        window.addEventListener('resize', this._update, { passive: true });
        this._wireDrag();
        requestAnimationFrame(this._update);
      }
      disconnectedCallback() { window.removeEventListener('resize', this._update); }
      step() {
        const cell = this.cells[0];
        if (!cell) return this.track.clientWidth * 0.8;
        const s = getComputedStyle(this.track);
        return cell.getBoundingClientRect().width + (parseFloat(s.columnGap || s.gap || '0') || 0);
      }
      index() { return Math.max(0, Math.min(this.cells.length - 1, Math.round(this.track.scrollLeft / this.step()))); }
      goTo(i) { this.track.scrollTo({ left: i * this.step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      page(dir) { this.goTo(this.index() + dir); }
      _update() {
        // every card fits across the screen (with the story gutters)? then centre the row instead of the peek layout
        const k = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--k')) || 1;
        const s = getComputedStyle(this.track), gap = parseFloat(s.columnGap || s.gap || '0') || 0;
        const cellW = this.cells[0] ? this.cells[0].getBoundingClientRect().width : 0;
        this.classList.toggle('is-fit', this.cells.length * (cellW + gap) - gap <= this.clientWidth - 64 * k);
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.nav) this.nav.hidden = !(max > 4);
        const x = this.track.scrollLeft, i = this.index();
        if (this.prevBtn) this.prevBtn.disabled = x <= 2;
        if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
        this.dots.forEach((d, j) => { d.classList.toggle('is-on', j === i); d.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        this.setAttribute('data-index', String(i));
      }
      _wireDrag() {
        const track = this.track;
        let down = false, moved = false, startX = 0, startLeft = 0;
        track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; });
        track.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); try { track.setPointerCapture(e.pointerId); } catch (err) {} }
          if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
        });
        const end = () => { if (!down) return; down = false; track.classList.remove('is-dragging'); };
        track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
        track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taste"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-taste> — deck switch (ARIA tabs) + tap-to-cycle stacks using the hero's deal geometry.
     Generic on purpose: any section may drop a [data-stack] of slots inside a <wyrdo-taste> (the WYLD LYFs section does). */
  if (!customElements.get('wyrdo-taste')) {
    const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
    const smooth = (t) => { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
    const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
    customElements.define('wyrdo-taste', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-deck]').forEach((tab) => tab.addEventListener('click', () => this.switchTo(tab.dataset.deck)));
        this.querySelectorAll('[data-stack]').forEach((st) => this._wireStack(st));
      }
      switchTo(deck) {
        this.querySelectorAll('[data-deck]').forEach((t) => { const on = t.dataset.deck === deck; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        this.querySelectorAll('[data-deck-panel]').forEach((p) => { p.hidden = p.dataset.deckPanel !== deck; });
        this.querySelectorAll('[data-stack]').forEach((st) => this._layout(st, st._k || 0, 0));
      }
      _slot(st, s) { s = Math.min(s, 2.4); const W = st.offsetWidth || 260; return { x: -0.12 * W * s, y: 6 * s, r: -2.5 * s }; }
      _layout(st, k, f) {
        const slots = Array.from(st.children).filter((c) => !c.classList.contains('wyrdo-nudge')), N = slots.length; if (!N) return;
        const W = st.offsetWidth || 260, back = this._slot(st, N - 1);
        for (let i = 0; i < N; i++) {
          const s = ((i - k) % N + N) % N; let x, y, r, z;
          if (s === 0) {
            if (f < 0.5) { const A = smooth(f * 2); x = -A * 0.95 * W; y = A * 40; r = -A * 22; z = 100; }
            else { const B = smooth(f * 2 - 1); x = -0.95 * W + B * (back.x + 0.95 * W); y = 40 + B * (back.y - 40); r = -22 + B * (back.r + 22); z = 100 - N; }
          } else { const a = this._slot(st, s), b = this._slot(st, s - 1), t = smooth(f); x = a.x + (b.x - a.x) * t; y = a.y + (b.y - a.y) * t; r = a.r + (b.r - a.r) * t; z = 100 - s; }
          slots[i].style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + r.toFixed(2) + 'deg)';
          slots[i].style.zIndex = z;
        }
        st._k = k;
      }
      _wireStack(st) {
        const N = Array.from(st.children).filter((c) => !c.classList.contains('wyrdo-nudge')).length;
        st._k = 0; this._layout(st, 0, 0);
        /* discoverability seal: a pulsing retro starburst on the front card, nudging "Tap to see more"; gone on the first deal */
        if (N > 1) {
          const nudge = document.createElement('div');
          nudge.className = 'wyrdo-nudge'; nudge.setAttribute('aria-hidden', 'true');
          nudge.innerHTML = '<svg class="wyrdo-nudge__burst" viewBox="0 0 100 100" aria-hidden="true"><path d="M 50,5 L 57.3,17.8 L 69.5,9.5 L 70.6,24.2 L 85.2,21.9 L 79.7,35.7 L 93.9,40 L 83,50 L 93.9,60 L 79.7,64.3 L 85.2,78.1 L 70.6,75.8 L 69.5,90.5 L 57.3,82.2 L 50,95 L 42.7,82.2 L 30.5,90.5 L 29.4,75.8 L 14.8,78.1 L 20.3,64.3 L 6.1,60 L 17,50 L 6.1,40 L 20.3,35.7 L 14.8,21.9 L 29.4,24.2 L 30.5,9.5 L 42.7,17.8 Z"/></svg><span class="wyrdo-nudge__label">Tap to<br>see more</span>';
          st.appendChild(nudge); st._nudge = nudge;
        }
        const cycle = () => {
          if (st._busy || N < 2) return;
          if (st._nudge) st._nudge.classList.add('is-gone');
          const from = st._k, to = (from + 1) % N;
          if (REDUCE.matches) { this._layout(st, to, 0); return; }
          st._busy = true; const start = performance.now(), dur = 560;
          const step = (now) => { const f = clamp((now - start) / dur, 0, 1); this._layout(st, from, f); if (f < 1) requestAnimationFrame(step); else { this._layout(st, to, 0); st._busy = false; } };
          requestAnimationFrame(step);
        };
        st.addEventListener('click', (e) => { if (e.target.closest('.wyrdo-censor')) return; cycle(); });
        st.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') { e.preventDefault(); cycle(); } });
        window.addEventListener('resize', () => this._layout(st, st._k || 0, 0), { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unlock-paths"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-claim> — opens the claim dialog, shows only the fields that belong to the chosen option, re-opens the
     dialog when Shopify's redirect comes back with a result, and hands a sent claim to Klaviyo (the form is a plain
     POST, so the values are stashed in sessionStorage on submit and read back on the reloaded page). */
  if (!customElements.get('wyrdo-claim')) {
    const STASH = 'wyrdo-tt-claim';
    customElements.define('wyrdo-claim', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const kind = this.querySelector('[data-claim-kind]');
        const sync = () => {
          const k = kind.selectedOptions[0].dataset.kind;
          this.querySelectorAll('[data-claim-for]').forEach((el) => {
            const off = !el.dataset.claimFor.split(' ').includes(k);
            el.hidden = off;
            el.querySelectorAll('input, select').forEach((f) => { f.disabled = off; });   // disabled = not required, not sent
          });
          // a field required only on some paths (the @handle is how a follow gets checked)
          this.querySelectorAll('[data-claim-required-for]').forEach((f) => { f.required = f.dataset.claimRequiredFor.split(' ').includes(k); });
        };
        // each card's button opens the dialog on its own path (data-claim-open = the option's data-kind)
        document.querySelectorAll('[data-claim-open]').forEach((btn) => btn.addEventListener('click', () => {
          const o = kind && [...kind.options].find((x) => x.dataset.kind === btn.dataset.claimOpen);
          if (o) { kind.value = o.value; sync(); }
          dialog.showModal();
        }));
        if (kind) {
          kind.addEventListener('change', sync); sync();
          // the browser has validated by now (submit never fires on an invalid form); a field the path hides is disabled and reads blank
          this.querySelector('form:not([method="dialog"])').addEventListener('submit', () => {
            const f = (n) => this.querySelector(`[data-claim-field="${n}"]`);
            const v = (n) => { const el = f(n); return el && !el.disabled ? el.value.trim() : ''; };
            const t = (n) => { const el = f(n); return !!(el && !el.disabled && el.checked); };
            const d = { pack: this.dataset.pack, path: kind.selectedOptions[0].dataset.kind, platform: v('platform'), handle: v('handle'), mate: v('mate'), link: v('link'), people_ok: t('people'), reuse_ok: t('reuse'), email: v('email') };
            try { sessionStorage.setItem(STASH, JSON.stringify(d)); } catch (e) {}
          });
        }

        if (this.querySelector('[data-claim-result]')) {
          dialog.showModal();
          // a reload must not bring the result back
          const url = new URL(window.location.href);
          url.searchParams.delete('contact_posted');
          window.history.replaceState({}, '', url.pathname + url.search);
          if (this.querySelector('[data-claim-result]:not(.is-error)')) this.sent();
        }
      }

      /* the sent state: the stashed claim becomes one Klaviyo event on the email's profile — identify + track,
         never consent, never a list. klaviyo (the app embed's object) first, the legacy _learnq queue second, else nothing. */
      sent() {
        let d = null;
        try { d = JSON.parse(sessionStorage.getItem(STASH)); sessionStorage.removeItem(STASH); } catch (e) {}
        if (!d || !d.email) return;
        const { email, ...props } = d;
        props.source = 'store-theme';
        const k = window.klaviyo, q = window._learnq;
        if (k && typeof k.identify === 'function') { k.identify({ $email: email }); k.track('Submitted T&T claim', props); }
        else if (q && typeof q.push === 'function') { q.push(['identify', { $email: email }]); q.push(['track', 'Submitted T&T claim', props]); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyr-demo"] && !Shopify.designMode) return;
  try {
    
  /* <wyrdo-demo> — playable one-question widget, app-faithful state machine (R3.5).
     initial -> select -> countdown(3,2,1) -> reveal. Colour flip on the section,
     "Your answer" tab, button->% morph, verdict (tie -> majority). localStorage per-qid.
     Static splits (data-split-a); no fetch/Convex yet (ST4.7 parked). */
  if (!customElements.get('wyrdo-demo')) {
    customElements.define('wyrdo-demo', class extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.vMin = this.dataset.verdictMinority || "You're a freaking WYRDO";
        this.vMaj = this.dataset.verdictMajority || 'You answered with the majority';
        this.section = this.closest('.wyrdo-demo-sec');
        this.cta = this.querySelector('[data-demo-cta]');
        this.questions = Array.from(this.querySelectorAll('[data-demo-question]'));
        this.index = this.questions.findIndex((q) => !q.hidden);
        if (this.index < 0) this.index = 0;
        this.timers = [];
        this.questions.forEach((q) => this.wire(q));
      }

      disconnectedCallback() { this.clearTimers(); }
      clearTimers() { this.timers.forEach((t) => clearTimeout(t)); this.timers = []; }

      wire(q) {
        const answers = q.querySelector('[data-demo-answers]');
        if (!answers) return;
        answers.querySelectorAll('[data-answer]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (q.dataset.state !== 'initial') return; // answered/counting -> ignore
            const choice = btn.dataset.answer;
            this.save(q.dataset.qid, choice);
            this.answer(q, choice, true);
          });
        });
        const next = q.querySelector('[data-demo-next]');
        if (next) next.addEventListener('click', () => this.advance());

        // Restore a previously-answered question straight to REVEAL (no animation).
        const saved = this.load(q.dataset.qid);
        if (saved === 'a' || saved === 'b') this.answer(q, saved, false);
      }

      // choice: 'a' | 'b'; animate: run the flip + countdown, else jump to reveal.
      answer(q, choice, animate) {
        const splitA = Math.max(0, Math.min(100, parseInt(q.dataset.splitA, 10) || 50));
        const splitB = 100 - splitA;
        const chosenPct = choice === 'a' ? splitA : splitB;
        // Minority (WYRDO) = your side's % is strictly lower. Tie -> majority (ADR-0020).
        const isMinority = chosenPct < 50;

        q.dataset.choice = choice;
        q.dataset.isMinority = isMinority ? '1' : '0';
        q.dataset.splitAPct = String(splitA);
        q.dataset.splitBPct = String(splitB);

        // Flip the section background to the chosen colour (if this is the active question).
        if (this.section && !q.hidden) this.section.dataset.demoAnswer = choice;

        // "Your answer" tab over the chosen button.
        const tabA = q.querySelector('[data-demo-tab-a]');
        const tabB = q.querySelector('[data-demo-tab-b]');
        if (tabA) tabA.hidden = choice !== 'a';
        if (tabB) tabB.hidden = choice !== 'b';

        // Mark the chosen button.
        q.querySelector('[data-demo-btn-a]').setAttribute('aria-pressed', String(choice === 'a'));
        q.querySelector('[data-demo-btn-b]').setAttribute('aria-pressed', String(choice === 'b'));

        if (animate && !this.reduce) {
          this.runCountdown(q, () => this.doReveal(q));
        } else {
          this.doReveal(q);
        }
      }

      runCountdown(q, done) {
        this.clearTimers();
        q.dataset.state = 'countdown';
        this.setStage(q, 'count');
        const count = q.querySelector('[data-demo-count]');
        const step = 800; // ~0.8s/step, snappy
        [3, 2, 1].forEach((n, i) => {
          this.timers.push(setTimeout(() => {
            count.hidden = false;
            count.textContent = String(n);
            // restart the pop animation on each tick
            count.style.animation = 'none';
            void count.offsetWidth;
            count.style.animation = '';
          }, i * step));
        });
        this.timers.push(setTimeout(done, 3 * step));
      }

      doReveal(q) {
        q.dataset.state = 'reveal';
        this.setStage(q, 'verdict');

        // Buttons morph: A/B faces -> the split %.
        const faceA = q.querySelector('[data-demo-face-a]');
        const faceB = q.querySelector('[data-demo-face-b]');
        faceA.textContent = q.dataset.splitAPct + '%';
        faceB.textContent = q.dataset.splitBPct + '%';

        // Verdict copy.
        const verdict = q.querySelector('[data-demo-verdict]');
        verdict.textContent = q.dataset.isMinority === '1' ? this.vMin : this.vMaj;

        if (this.cta) this.cta.hidden = false;
      }

      // Show exactly one of the LEFT stage states.
      setStage(q, which) {
        const intro = q.querySelector('[data-demo-intro]');
        const count = q.querySelector('[data-demo-count]');
        const vwrap = q.querySelector('[data-demo-verdict-wrap]');
        if (intro) intro.hidden = which !== 'intro';
        if (count) count.hidden = which !== 'count';
        if (vwrap) vwrap.hidden = which !== 'verdict';
      }

      // Advance to the next question (wraps), resetting it to INITIAL.
      // Animation: the CURRENT card slides DOWN into the slot (clipped), then the NEXT card
      // pops UP from below the slot. Reduced-motion → instant swap (no slide).
      advance() {
        this.clearTimers();
        const cur = this.questions[this.index];
        const curMover = cur.querySelector('[data-demo-cardmover]');

        if (this.reduce || !curMover) {
          this.swap(cur);
          return;
        }

        // Slide the current card DOWN out of the slot, then swap once it's clipped.
        // done() is guarded so the transitionend and the safety-timeout can't BOTH swap
        // (a double swap advanced twice + left a card stuck at translateY below the slot).
        let swapped = false;
        curMover.dataset.slide = 'out';
        const done = () => {
          if (swapped) return;
          swapped = true;
          clearTimeout(fallback);
          curMover.removeEventListener('transitionend', onEnd);
          this.swap(cur);
        };
        const onEnd = (e) => { if (e.target === curMover && e.propertyName === 'transform') done(); };
        curMover.addEventListener('transitionend', onEnd);
        // Fallback in case transitionend never fires (interrupted transition).
        const fallback = setTimeout(done, 420);
        this.timers.push(fallback);
      }

      // Hide `cur`, reveal the next question, and pop its card UP from the slot.
      swap(cur) {
        const curMover = cur.querySelector('[data-demo-cardmover]');
        cur.hidden = true;
        if (curMover) delete curMover.dataset.slide; // reset for when it wraps back around
        this.index = (this.index + 1) % this.questions.length;
        const nxt = this.questions[this.index];
        const nxtMover = nxt.querySelector('[data-demo-cardmover]');

        // Reset the section colour back to the section's own colourway.
        if (this.section) delete this.section.dataset.demoAnswer;
        if (this.cta) this.cta.hidden = true;

        // If the next question was already answered, show its reveal; else fresh INITIAL.
        const saved = this.load(nxt.dataset.qid);

        // Clear any stale inline transform (e.g. a prior pop-timer cancelled by rapid Next clicks)
        // so the pre-place below starts clean.
        if (nxtMover) nxtMover.style.transform = '';

        // Pre-place the next card BELOW the slot via an INLINE transform, while it's still hidden
        // (display:none suppresses any transition). We never touch `transition` — the base rule's
        // `transition: transform` stays active — so the later single transform mutation is a clean
        // 110% -> 0 the browser reliably animates (setting transition:none here made removing it
        // race the transform change and the pop stuck below the slot; rAF is throttled in preview).
        if (nxtMover && !this.reduce) nxtMover.style.transform = 'translateY(110%)';

        // Reveal the next question (can't transition from display:none, so unhide first).
        nxt.hidden = false;
        if (saved === 'a' || saved === 'b') {
          this.answer(nxt, saved, false);
          if (this.section) this.section.dataset.demoAnswer = saved;
        } else {
          this.resetQuestion(nxt);
        }

        // A tick later (macrotask — rAF is throttled in the theme preview), clear the inline
        // transform: a single property change 110% -> 0 that the base transition pops UP.
        if (nxtMover && !this.reduce) {
          this.timers.push(setTimeout(() => { nxtMover.style.transform = ''; }, 20));
        }

        // Move focus to the freshly shown question's stage for keyboard users.
        const focusTarget = nxt.querySelector('[data-demo-answers] [data-answer]') || nxt;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      }

      resetQuestion(q) {
        q.dataset.state = 'initial';
        delete q.dataset.choice;
        if (this.cta) this.cta.hidden = true;
        this.setStage(q, 'intro');
        const answers = q.querySelector('[data-demo-answers]');
        if (answers) answers.hidden = false;
        const tabA = q.querySelector('[data-demo-tab-a]');
        const tabB = q.querySelector('[data-demo-tab-b]');
        if (tabA) tabA.hidden = true;
        if (tabB) tabB.hidden = true;
        const faceA = q.querySelector('[data-demo-face-a]');
        const faceB = q.querySelector('[data-demo-face-b]');
        if (faceA) faceA.textContent = 'A';
        if (faceB) faceB.textContent = 'B';
        q.querySelector('[data-demo-btn-a]').setAttribute('aria-pressed', 'false');
        q.querySelector('[data-demo-btn-b]').setAttribute('aria-pressed', 'false');
      }

      key(qid) { return 'wyrdo-demo:' + qid; }
      load(qid) { try { return localStorage.getItem(this.key(qid)); } catch (e) { return null; } }
      save(qid, v) { try { localStorage.setItem(this.key(qid), v); } catch (e) {} }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
